/**
 * The frame a drawing is served in, and its palette. A cut of ugio_klase's
 * `child/priemones/kit.tsx`: only what the Laipsnis drawing imports, with the
 * Tailwind classes replaced by this client's own CSS (`index.css`, `.priemone`).
 * `laipsnis.tsx` beside it is copied verbatim and imports exactly these names.
 *
 * The frame is deliberately quieter than the question above it: cream on
 * cream, one line of label. It has to be legible without competing, because
 * the question is the thing being asked and this is what lies next to it.
 */
import type { ReactNode } from "react";

export const INK = "#3D2C1E";
export const FAINT = "#A0845C";
export const FILL = "#AEDCDA";
export const PAPER = "#FFFFFF";
export const FONT = "Nunito, sans-serif";

export function Priemone({ label, action, children }: { label?: string; action?: ReactNode; children: ReactNode }) {
  return (
    <section className="priemone">
      <div className="priemone-head">
        {label && <p className="priemone-label">{label}</p>}
        {action}
      </div>
      <div className="priemone-body">{children}</div>
    </section>
  );
}

/** The way back to the start, on every material, one click from wherever she took it. */
export function Reset({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" onClick={onClick} className="quiet-link">
      Iš naujo
    </button>
  );
}
